export default function(data) {
  return {
    endDate: data.endDate ? new Date(Number(data.endDate) * 1000) : '',
    startDate: new Date(Number(data.startDate) * 1000),
  }
}
